<div class="dialog-container">
    <div class="main-text">
        {{
            "mimic.notification.title"
                | translate: { channelName: data.channelName }
        }}
    </div>
    <div class="sub-text">
        <ng-container *ngIf="data.action">
            {{
                "mimic.notification.action" | translate: { action: data.action }
            }}
        </ng-container>
        <ng-container *ngIf="data.newValue">
            {{
                "mimic.notification.value"
                    | translate
                        : {
                              currentValue: data.currentValue,
                              newValue: data.newValue,
                              units: data.units,
                          }
            }}
        </ng-container>
    </div>
    <div class="buttons-container">
        <div class="cancel" (click)="cancel()">
            {{ "mimic.notification.button.cancel" | translate }}
        </div>
        <div class="confirm" (click)="confrim()">
            {{ "mimic.notification.button.confirm" | translate }}
        </div>
    </div>
</div>
